import type { CityConfig } from "../city-template/types";

export const ottumwaConfig: CityConfig = {
  city: "Ottumwa",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "ottumwa",
  route: "/cities/ottumwa",
  title: "Emergency Passport Ottumwa, IA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Ottumwa, IA — as fast as 24 hours. Serving Wapello County and Southeast Iowa. A+ BBB rated registered State Dept. courier serving John Deere professionals, IHCC students, and Des Moines River families. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Ottumwa, IA",
  heroSubtitle: "John Deere business trip to Germany with two weeks notice? IHCC study abroad program and no passport yet? Family wedding in Mexico and your documents expired? We help Ottumwa and Southeast Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Ottumwa%20Iowa%20City%20of%20Bridges%20along%20the%20Des%20Moines%20River%20with%20historic%20downtown%20architecture%20and%20riverfront%20park%20landscape%20Southeast%20Iowa%20at%20golden%20hour%20warm%20sunlight%20professional%20photography%20vibrant%20prairie%20scenery&width=1800&height=700&seq=ottumwa-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Ottumwa Iowa City of Bridges along the Des Moines River Southeast Iowa at golden hour",
  geoPosition: "41.0200;-92.4114",
  geoPlacename: "Ottumwa, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 300 miles east of Ottumwa via US-34 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Ottumwa", zips: "52501" },
    { name: "Fairfield", zips: "52556" },
    { name: "Oskaloosa", zips: "52577" },
    { name: "Pella", zips: "50219" },
    { name: "Knoxville", zips: "50138" },
    { name: "Albia", zips: "52531" },
    { name: "Centerville", zips: "52556" },
    { name: "Bloomfield", zips: "52537" },
    { name: "Sigourney", zips: "52591" },
    { name: "Keosauqua", zips: "52565" },
    { name: "Mount Pleasant", zips: "52641" },
    { name: "Burlington", zips: "52601" },
    { name: "Fort Madison", zips: "52627" },
    { name: "Keokuk", zips: "52632" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Newton", zips: "50208" },
    { name: "Grinnell", zips: "50112" },
    { name: "Washington", zips: "52353" },
    { name: "Kirksville, MO", zips: "63501" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southeast Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "SE Iowa Coverage", desc: "Serving Wapello, Jefferson, Mahaska, and surrounding counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Emergency passport help in Davenport, IA", route: "/cities/davenport" },
    { name: "Urgent passport services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Same-day passport help in Ames, IA", route: "/cities/ames" },
    { name: "Passport courier services in Burlington, IA", route: "/cities/burlington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Ottumwa remotely via secure courier. We do not have a walk-in office in Ottumwa — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wapello County and the entire Southeast Iowa region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wapello County and the Southeast Iowa region including Jefferson, Mahaska, Davis, Monroe, Appanoose, and Keokuk counties",
  serviceAreaIntro: "From the historic bridges spanning the Des Moines River in downtown Ottumwa to the John Deere Ottumwa Works and manufacturing corridor, from the campus of Indian Hills Community College to the farm communities of Fairfield and Oskaloosa, from the historic districts of Centerville and Bloomfield to the Amish countryside of rural Davis County — Fast Passport Center serves the entire Southeast Iowa region. We regularly help travelers from Ottumwa, Fairfield, Oskaloosa, Pella, and Centerville get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Ottumwa neighborhoods and the surrounding Southeast Iowa area including Fairfield, Oskaloosa, Pella, Knoxville, Albia, Centerville, Bloomfield, Sigourney, Mount Pleasant, Burlington, Fort Madison, and Keokuk. If you are anywhere in Wapello County, Jefferson County, or the Southeast Iowa region, we have you covered.",
  howItWorksIntro: "Most Ottumwa travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Southeast Iowa travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Ottumwa and Wapello County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Ottumwa? Here are the most common ones we hear from Southeast Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ottumwa travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Greg P.",
      location: "Ottumwa, IA",
      rating: 5,
      text: "John Deere sent me to Germany on short notice and my passport had expired. Fast Passport Center renewed it in 30 hours. Ottumwa Works colleagues use them now too.",
      service: "Passport Renewal",
    },
    {
      name: "Amy T.",
      location: "Fairfield, IA",
      rating: 5,
      text: "Emergency passport for my mother's funeral in England. Got it in 26 hours. Fast Passport Center handled everything while I took care of family. Truly grateful.",
      service: "Emergency Passport",
    },
    {
      name: "Carlos R.",
      location: "Ottumwa, IA",
      rating: 5,
      text: "IHCC student studying abroad in Spain. First passport and I waited too long to apply. Fast Passport Center had it in 4 days. All the other students were jealous of how fast it was.",
      service: "New Passport",
    },

  ],
  facilities: [
    {
      id: "ott-1",
      name: "Ottumwa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 W 2nd St",
      city: "Ottumwa",
      state: "IA",
      zip: "52501",
      phone: "(641) 682-6291",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ottumwa facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "ott-2",
      name: "Wapello County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "101 W 4th St",
      city: "Ottumwa",
      state: "IA",
      zip: "52501",
      phone: "(641) 683-4610",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Ottumwa Courthouse",
      website: "https://www.wapellocounty.org/recorder",
      websiteLabel: "Wapello County Recorder",
      notes: "Accepts passport applications. Good alternative to post office with extended hours.",
      icon: "ri-government-line",
    },
    {
      id: "ott-3",
      name: "Fairfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W Broadway Ave",
      city: "Fairfield",
      state: "IA",
      zip: "52556",
      phone: "(641) 472-4111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jefferson County and MUM community. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ott-4",
      name: "Oskaloosa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "108 1st Ave E",
      city: "Oskaloosa",
      state: "IA",
      zip: "52577",
      phone: "(641) 673-7071",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles northwest of Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mahaska County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ott-5",
      name: "Pella Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "703 Main St",
      city: "Pella",
      state: "IA",
      zip: "50219",
      phone: "(641) 628-4021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "50 miles northwest of Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marion County and Central College community. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "ott-6",
      name: "Burlington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 N Main St",
      city: "Burlington",
      state: "IA",
      zip: "52601",
      phone: "(319) 753-2171",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles southeast of Ottumwa",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Des Moines County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "SE Iowa photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wapello County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many SE Iowa applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many SE Iowa families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Ottumwa travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Ottumwa." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ottumwa address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Ottumwa before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Ottumwa for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Ottumwa?", a: "Fast Passport Center offers fast passport renewal in Ottumwa in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Ottumwa?", a: "The nearest regional passport agency to Ottumwa is the Chicago Passport Agency, approximately 300 miles east via US-34 and I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Ottumwa without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Ottumwa?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Ottumwa — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wapello County and SE Iowa residents." },
    { q: "Do you serve the entire Southeast Iowa region?", a: "Absolutely. Fast Passport Center serves the entire Southeast Iowa region including Ottumwa, Fairfield, Oskaloosa, Pella, Knoxville, Albia, Centerville, Bloomfield, and surrounding communities. Our courier service works seamlessly from any address in Wapello County, Jefferson County, and SE Iowa." },
    { q: "Can I expedite a child passport in Ottumwa?", a: "Yes. Fast Passport Center expedites child passports in Ottumwa for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk SE Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Ottumwa with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walgreens — Ottumwa", address: "1140 N Quincy Ave, Ottumwa, IA 52501", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Ottumwa", address: "1940 Venture Dr, Ottumwa, IA 52501", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Fairfield", address: "2701 W Burlington Ave, Fairfield, IA 52556", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Oskaloosa", address: "301 1st Ave E, Oskaloosa, IA 52577", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Pella", address: "1650 Washington St, Pella, IA 50219", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Iowa City", address: "125 S Dubuque St, Iowa City, IA 52240", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Ottumwa Driver's License",
      address: "13011 120th Ave, Ottumwa, IA 52501",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Wapello County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Fairfield Driver's License",
      address: "200 W Briggs Ave, Fairfield, IA 52556",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Jefferson County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Oskaloosa Driver's License",
      address: "2174 Highway 163, Oskaloosa, IA 52577",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Mahaska County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "OTM",
      name: "Ottumwa Regional Airport",
      distance: "5 miles north of downtown Ottumwa",
      address: "14802 Terminal St, Ottumwa, IA 52501",
      note: "Regional airport with general aviation and charter services. About 10 minutes from downtown Ottumwa.",
      flightUrl: "https://www.ottumwa.us/departments/airport/",
      flightLabel: "OTM Airport",
      featured: true,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "90 miles northwest of Ottumwa",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 1 hour 30 minutes from Ottumwa.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "90 miles northeast of Ottumwa",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 1 hour 30 minutes from Ottumwa.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
  ],
};